"use client";

import { useEffect } from "react";

const COOKIE_NAME = "blvmy_tz";
const ONE_YEAR = 60 * 60 * 24 * 365;

// Identifiant IANA : lettres, chiffres, et les séparateurs des noms de zones
// ("Europe/Paris", "America/Argentina/Buenos_Aires", "Etc/GMT+2"). Filtre
// volontairement étroit, pour n'écrire dans le cookie que ce qui a une chance
// d'être accepté par le back, qui revalide de toute façon.
const IANA_LIKE = /^[A-Za-z0-9_+\-/]{3,64}$/;

/**
 * Publie le fuseau du navigateur dans un cookie, pour que le serveur puisse le
 * transmettre à /refresh-user et resynchroniser le compte.
 *
 * Pourquoi un cookie : le fuseau n'existe que côté client, alors que l'appel à
 * /refresh-user part du callback de session, côté serveur. Le commentaire du
 * back affirmait depuis longtemps que « le web resynchronise le fuseau à chaque
 * visite », mais le corps de la requête ne portait aucun champ timezone : un
 * utilisateur qui déménageait gardait son ancien minuit indéfiniment, et avec
 * lui ses rappels de série à la mauvaise heure. Le mobile, lui, l'envoyait déjà.
 *
 * Même durée que le cookie d'appareil, et pas de httpOnly puisque c'est
 * justement le client qui l'écrit. Le back valide l'identifiant et n'écrit rien
 * si la valeur est inchangée ou inconnue.
 */
export default function TimezoneSync() {
    useEffect(() => {
        try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (!tz || !IANA_LIKE.test(tz)) return;

            const already = document.cookie
                .split("; ")
                .some((c) => c === `${COOKIE_NAME}=${tz}`);
            if (already) return;

            const secure =
                window.location.protocol === "https:" ? "; secure" : "";
            document.cookie = `${COOKIE_NAME}=${tz}; path=/; max-age=${ONE_YEAR}; samesite=lax${secure}`;
        } catch {
            // Intl indisponible ou cookies refusés : le compte garde son fuseau
            // actuel, exactement comme avant ce composant.
        }
    }, []);

    return null;
}
